import React from "react";

export const defaultWellbeingRows = {
  label:
    "Cost incurred on well-being measures as a % of total revenue of the company",
  currentFY: "",
  previousFY: "",
};

const WellBeingCostTable = ({ wellbeingdata, setWellbeingData }) => {
  const handleChange = (field, value) => {
    const updated = { ...wellbeingdata, [field]: value };
    setWellbeingData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          borderCollapse: "collapse",
          width: "100%", // 🔽 reduced first column width
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={headerStyle}></th>
            <th style={headerStyle}>
              FY ____
              <br />
              Current Financial Year
            </th>
            <th style={headerStyle}>
              FY ____
              <br />
              Previous Financial Year
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ ...cellStyle, fontWeight: "bold", textAlign: "left" }}>
              Cost incurred on well-being measures as a % of total revenue of
              the company
            </td>
            <td style={cellStyle}>
              <input
                type="text"
                placeholder="Current FY"
                value={wellbeingdata.currentFY}
                onChange={(e) => handleChange("currentFY", e.target.value)}
                style={inputStyle}
              />
            </td>
            <td style={cellStyle}>
              <input
                type="text"
                placeholder="Previous FY"
                value={wellbeingdata.previousFY}
                onChange={(e) => handleChange("previousFY", e.target.value)}
                style={inputStyle}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  height: "80px",
};

const cellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  height: "120px", // make table body taller
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "4px",
  textAlign: "center",
  outline: "none",
  backgroundColor: "white",
};

export default WellBeingCostTable;
